import React, { useState, useEffect, useLayoutEffect } from 'react';
import { BradcamArea } from '../../dumb/bradcam-area/BradcamArea';
import { ServiceDetailArea } from '../../dumb/service-detail-area/ServiceDetailArea';
import { ProjectArea } from '../../dumb/project-area/ProjectArea';
import { Footer } from '../../dumb/footer/Footer';
import { TestForm } from '../../dumb/test-form/TestForm';
import { ScriptContainer } from '../../smart/script/ScriptContainer';
import { Loader } from '../utils/loader/Loader';

type props = {}

export const SingleService = (props: any) => {

    const [isOnline, setIsOnline] = useState(false);
    
    useLayoutEffect(() =>

        setIsOnline(true), [setIsOnline]
    );

    // useLayoutEffect(() =>

    //     console.log("sono single service ", props.contents)
    // );

    if (isOnline === false) {
        return <Loader />;
    }

    else {
        $('html, body').scrollTop(0)
        return <div>
            {/**bradcam area */}
            < BradcamArea {...props} title={props.contents.title} filename={props.filename}/>
            {/**service detail area */}
            < ServiceDetailArea {...props} contents={props.contents} filename={props.filename}/>
            {/**project area component */}
            < ProjectArea clickhandler={props.clickhandler}/>
            {/**footer area component */}
            < Footer clickhandler={props.clickhandler}/>
            {/**test form component */}
            < TestForm />
            {/**public scripts loader */}
            < ScriptContainer {...props} count={props.count} />
        </div>
    }
}